import { render, staticRenderFns } from "./TalkRoom.vue?vue&type=template&id=287202a5&scoped=true"
import script from "./TalkRoom.vue?vue&type=script&lang=js"
export * from "./TalkRoom.vue?vue&type=script&lang=js"
import style0 from "./TalkRoom.vue?vue&type=style&index=0&id=287202a5&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "287202a5",
  null
  
)

export default component.exports